import React from "react";
import CustomDropdown from "../../../dropdown/CustomDropdown";

const rolesData = [
    {
      id: 1,
      name: "Super Admin",
    },
    {
      id: 2,
      name: "Admin",
    },
    {
      id: 3,
      name: "User",
    },
  ];

const AdminProfileTeam = () => {
  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white flex xl:items-center justify-between flex-col xl:flex-row">
      <h5 className="text-base font-bold leading-[160%] text-customGray mb-4">
        Team
      </h5>
      <CustomDropdown
        options={rolesData.map((data) => data.name)}
        classes="px-[14px] md:p-5 border border-strokeColor rounded-[10px] h-12 lg:h-[60px] bg-white flex items-center justify-between w-full min-w-auto md:min-w-[381px]"
        textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm lg:text-base font-medium text-customGray"
        rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
        menuClasses="absolute left-0 z-10 mt-5 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      />
    </div>
  );
};

export default AdminProfileTeam;
